import "./static.scss";
import "../common/tooltip/tippy.scss";
import { createStaticPageApp } from "./createStaticPageApp";

function mountStaticPages() {
    document.querySelectorAll(".static-page-content").forEach(el => {
        const contentEl = el.closest("[data-content]") as HTMLElement;
        if (!contentEl?.dataset.content) {
            return;
        }

        const model = JSON.parse(contentEl.dataset.content);
        contentEl.removeAttribute("data-content");
        
        const app = createStaticPageApp(model, {
            isMobile: false,
            resources: window.Resources ?? {},
            ssr: true
        });
        app.mount(el);
    })
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mountStaticPages, { once: true });
} else {
    mountStaticPages();
}

